export const BID_COMPLIANCE_CRITERION_ID = 'compliance';
export const BID_QUALIFICATION_CRITERION_ID = 'qualification';
export const BID_DELIVERABLES_VIEWS = ['list', 'grid'] as const;
export const BID_DELIVERABLES_ORDER_FIELDS = ['status', 'sourceOrder'] as const;
export const BID_DELIVERABLE_STATUSES = [
  'missing',
  'in_progress',
  'in_review',
  'ready_to_submit',
] as const;
export const BID_DELIVERABLE_STATUS_TEXT = {
  missing: { en: 'Missing', nb: 'Mangler' },
  in_progress: { en: 'In progress', nb: 'Pågår' },
  in_review: { en: 'In review', nb: 'Til gjennomgang' },
  ready_to_submit: { en: 'Ready to submit', nb: 'Klar til innsending' },
};
export const BID_DELIVERABLE_FILE_EXTENSIONS = ['.pdf', '.docx', '.doc', '.xlsx', '.xlsm', '.csv'];
